import React from 'react'
import PropTypes from 'prop-types'

const CourseSlug = ({course}) => {
  return (
    <span style={{ fontSize: '12px' }}>
      {course.external_url != '' ? <a style={{ color: '#0093c5'}} href={course.external_url} target="_blank">{course.slug}</a> : course.slug}
    </span>
  )
}

CourseSlug.propTypes = {
  course: PropTypes.shape({
    external_url: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired
  })
}

export default CourseSlug


// WEBPACK FOOTER //
// ./src/components/rank/CourseSlug.js